import request from '@/utils/request'
 // 查询供应商产能均衡列表
 export function apiScpSopMpsSupplierCapacityBalanceList (query) {
    return request({
      url: `/scp/scpSopMpsSupplierCapacityBalance/list`,
      method: 'get',
      params: query
    })
  }
   // 计算供应商产能均衡
 export function apiScpCalculateCapacityBalance (query) {
    return request({
      url: `/scp/scpSopMpsSupplierCapacityBalance/calculateCapacityBalance`,
      method: 'get',
      params: query
    })
  }

     // 修改供应商产能均衡
 export function apiUpdateScpSopMpsSupplierCapacityBalance (query) {
    return request({
      url: `/scp/scpSopMpsSupplierCapacityBalance`,
      method: 'put',
      data: query
    })
  }
